import { memo } from 'react'

/**
 * Format time from 24-hour to 12-hour format
 * @param {string} time - Time in HH:MM format (e.g., "14:30")
 * @returns {string} Time in 12-hour format (e.g., "2:30 PM")
 */
const formatTime = (time) => {
  const [hours, minutes] = time.split(':').map(Number)
  const period = hours >= 12 ? 'PM' : 'AM'
  const displayHours = hours % 12 || 12
  return `${displayHours}:${minutes.toString().padStart(2, '0')} ${period}`
}

/**
 * TimeSlot Component
 * Individual time slot button with empire theme styling
 *
 * @param {Object} props - Component props
 * @param {Object} props.slot - Slot object {id, start, end}
 * @param {Function} props.onSelect - Callback when slot is selected
 * @param {boolean} props.isSelected - Whether this slot is currently selected
 */
const TimeSlot = ({ slot, onSelect, isSelected }) => {
  const startTime = formatTime(slot.start)
  const endTime = formatTime(slot.end)

  const baseStyles = "px-4 py-3 rounded-lg border-2 transition-all duration-300 font-medium text-sm cursor-pointer"

  const stateStyles = isSelected
    ? "bg-secondary text-black border-secondary shadow-md scale-105 font-bold"
    : "bg-white text-primary border-secondary/30 hover:bg-secondary/10 hover:border-secondary hover:scale-105"

  return (
    <button
      onClick={() => onSelect(slot)}
      className={`${baseStyles} ${stateStyles}`}
      aria-label={`Time slot from ${startTime} to ${endTime}`}
      aria-pressed={isSelected}
    >
      <div className="flex items-center justify-center gap-1">
        <span>{startTime}</span>
        <span className="text-gray-400">-</span>
        <span>{endTime}</span>
      </div>
    </button>
  )
}

// Memoize to prevent unnecessary re-renders
export default memo(TimeSlot)
